<script lang="ts">
export default {
  name: 'AccountBenchmarkViewOptions',
};
</script>

<script setup lang="ts">
import { ref, watch } from 'vue';
import { Layout } from '@lucide/vue';
import FilterButton from '@/components/v2/FilterButton.vue';
import AppButton from '@/components/v2/AppButton.vue';
import RadioGroup from '@/components/v2/RadioGroup.vue';

const props = withDefaults(
  defineProps<{
    /** Current selection: 'showAll' | 'showNone' */
    labels?: string;
  }>(),
  { labels: 'showAll' },
);

const emit = defineEmits<{
  change: [value: string];
}>();

const LABEL_OPTIONS: { label: string; value: string }[] = [
  { label: 'Show All', value: 'showAll' },
  { label: 'Show None', value: 'showNone' },
];

const draft = ref<string>(props.labels);

watch(
  () => props.labels,
  (val) => {
    draft.value = val ?? 'showAll';
  },
  { immediate: true },
);

function onSave(payload: unknown) {
  if (typeof payload === 'string') emit('change', payload);
}
</script>

<template>
  <FilterButton
    title="View Options"
    :icon="Layout"
    start
    data-test-activator="account-benchmark-view-options-activator"
    @save="onSave">
    <template #menu="{ save }">
      <div class="flex flex-col">
        <h4 class="border-b border-gray-200 px-4 py-3 text-sm font-medium text-gray-900">View Options</h4>
        <div class="px-4 py-3">
          <h5 class="mb-2 text-xs font-medium tracking-wide text-gray-500 uppercase">Client Names</h5>
          <RadioGroup
            v-model="draft"
            :options="LABEL_OPTIONS"
            layout="vertical"
            class="gap-2" />
        </div>
        <div class="flex justify-end gap-2 border-t border-gray-200 bg-gray-50 px-4 py-3">
          <AppButton
            primary
            data-test="account-benchmark-view-options-apply"
            @click="save(draft)">
            Done
          </AppButton>
        </div>
      </div>
    </template>
  </FilterButton>
</template>
